import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Sidebar from "./layout/Sidebar";
import AddPlan from "./add/AddPlan"
import EditPlan from "./edit/EditPlan"
import ViewPlan from "./view/ViewPlan"

export default function PlanPanel() {

  const role=localStorage.getItem("role");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [addform, setaddform] = useState(false);
  const [editform, seteditform] = useState(false);
  const [view, setview] = useState(false);
  const [id, setId] = useState(0);

  const handleDelete = (id) => {
    if(!confirm("Delete confirmation!")) {return;} 
    axios.delete(`${process.env.REACT_APP_BASE_URL}api/plan/secured/deletePlan/`+id)
        .then(result=>{alert("Delete Successfully!");getData();})
        .catch(err=>console.log(err));
  };

  const columns = [
    { name: "ID", selector: (row,index) => index+1, sortable: true },
    { name: "Plan Type", selector: row => row.planType || "N/A", sortable: true },
    { name: "Price", selector: row => row.price , sortable: true },
    { name: "Expired Date", selector: row => new Date(row.expiredDate).toLocaleDateString("en-GB") || "N/A", sortable: true },
    { name: "Status",selector: row => row.status || "N/A",sortable: true, cell: row => (
      <span
        style={{
          color: row.status==="Active" ? "green" : "red",
          fontWeight: 600,
        }}>{row.status || "N/A"}</span>),},
        ...(role === "Admin"? [
        {
          name: "User Id",
          selector: row => row.userId || "0",
          sortable: true,
        },
      ]: []),

    // ✅ Actions Column
    {
      name: "Actions",
      cell: row => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-color me-2"
            onClick={() => {setview(true);setId(row.id)}}
          >
            <i className="bi bi-eye"></i>
          </button>
          {role==="Admin" &&
          <button
            className="btn btn-sm btn-color me-2"
             onClick={() => {seteditform(true);setId(row.id)}}
          >
            <i className="bi bi-pencil"></i>
          </button>}
          {role==="Admin" &&
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
          </button>}
        </div>
      ),
    },
  ];

  function getData(status){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/plan/secured/getPlanByStatus/`+status)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  function getLoginData(){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/plan/secured/getPlanByLoginUser`)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  if(role==="Admin"){useEffect(()=>getData("Active"),[]);}else{useEffect(()=>getLoginData(),[]);}

  const filteredData = filterText
    ? data.filter(item =>
        (item.fullname || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.email || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.mobile || "").toLowerCase().includes(filterText.toLowerCase()) 
      )
    : data;

    return (<>
      <div className="container-fluid">
        {addform && <>
        <div className="dialog-container">
          <AddPlan event={setaddform}></AddPlan>
        </div>
        </>}
        {view && <>
        <div className="dialog-container">
          <ViewPlan event={setview} id={id}></ViewPlan>
        </div>
        </>}
        {editform && <>
        <div className="dialog-container">
          <EditPlan event={seteditform} id={id}></EditPlan>
        </div>
        </>}
      </div>
      <div className="container-fluid">
          <div className="row">
             <div className="col-12 col-md-3 col-lg-2 sidebar-container">
                 <Sidebar></Sidebar>
             </div>
             <div className="col-12 col-md-9 col-lg-10 main-container">
                 <div className="container mt-4">
                  <h2 className="text-center mb-3">Plan List</h2>
                  <hr />
    
                  {/* Action Buttons + Search Bar */}
                  <div className="row d-flex justify-content-between align-items-center mb-0">
                    <div className="col col-sm-2">
                      {role==="User" &&
                        <button className="btn btn-color text-center" onClick={()=>setaddform(true)}><i className="bi bi-plus"></i></button>
                      }
                    </div>
                    <div className="col-12 col-lg-2">
                      {role==="Admin" &&
                      <select className="form-select" name="status" onChange={(e)=>getData(e.target.value)}>
                        <option>Active</option>
                        <option>Pending</option>
                        <option>Rejected</option>
                        <option>Inactive</option>
                      </select>
                      }
                    </div>
                    <div className="col-12 col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "100%" }}
                        placeholder="Search"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Data Table */}
                  <div className="card shadow" style={{overflow:"auto"}}>
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
             </div>
          </div>
      </div> 
    </>);
}